export const LIVE_ONBOARDING_BOOKING_URL =
  'https://calendly.com/d/dv7q-pv2-sr7/live-onboarding-catch-up-bookkeeping'

export const LIVE_ONBOARDING_CALL_NAME = 'Live Onboarding: Catch-up Bookkeeping'

export const ALI_PHOTO_URL =
  'https://heard-images.s3.amazonaws.com/assets/ali.png'

export const ROBBY_PHOTO_URL =
  'https://heard-images.s3.amazonaws.com/assets/robby.png'

export const LIVE_ONBOARDING_SKIP_KEY_PREFIX = 'liveOnboardingBookingSkipped'

export const BOOKING_POLL_INTERVAL_MS = 2000

export const BOOKING_POLL_MAX_ATTEMPTS = 15
